/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ERC2771Context,
  ERC2771ContextInterface,
} from "../ERC2771Context";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class ERC2771Context__factory {
  static readonly abi = _abi;
  static createInterface(): ERC2771ContextInterface {
    return new Interface(_abi) as ERC2771ContextInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ERC2771Context {
    return new Contract(address, _abi, runner) as unknown as ERC2771Context;
  }
}
